var map = {
	"./AZUR-LANE_en.png": 4887,
	"./AZUR-LANE_jp.png": 2437,
	"./AZUR-LANE_kr.png": 786,
	"./AZUR-LANE_zh-tw.png": 2108,
	"./AZUR-LANE_zh.png": 4579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6910;